import { render, staticRenderFns } from "./UniqueCount.vue?vue&type=template&id=0188eb5e&scoped=true&"
import script from "./UniqueCount.vue?vue&type=script&lang=js&"
export * from "./UniqueCount.vue?vue&type=script&lang=js&"
import style0 from "./UniqueCount.vue?vue&type=style&index=0&id=0188eb5e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0188eb5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VRow})
